export const SignalFunctions = {
    refreshData: "refreshData",
    activityLogsUpdated: "activityLogsUpdated",
    pushedNotification: "pushedNotification",
    deletedNotification: "deletedNotification",
    videoCallRequested: "videoCallRequested",
    videoCallAccepted: "videoCallAccepted",
    videoCallEnded: "videoCallEnded",
    monitoringResultsUpdated: "monitoringResultsUpdated",
    scheduledMaintenancesChanged: "ScheduledMaintenancesChanged",
    scheduledMaintenanceForceStart: "ScheduledMaintenanceForceStart",
    entitiesMetadataChanged: "entitiesMetadataChanged",
    vetPendingEmailsChanged: "VetPendingEmailsChanged",
    vetHistoryChanged: "VetHistoryChanged",
    vetTaskUpdateChanged: "VetTaskUpdateChanged",
    refreshVet: "RefreshVet",
    refreshAutoScreening: "RefreshAutoScreening",
    autoScreeningVetTaskUpdateChanged: "AutoScreeningVetTaskUpdateChanged",
    autoScreeningHistoryChanged: "AutoScreeningHistoryChanged",
    refreshComments: "RefreshComments",
    onSubtaskCorrespondenceReply: "OnSubtaskCorrespondenceReply",
    crewWelfareStatusChanged: "CrewWelfareStatusChanged",
    rightShipInspectionDocumentsParsedChanged: "RightShipInspectionDocumentsParsedChanged",
    formStatusChanged: "FormStatusChanged",
    subtaskStatusChanged: "SubtaksStatusChanged",
    vesselPreArrivalStatusChanged: "VesselPreArrivalStatusChanged",
    safetyRatingReviewTaskUpdateChanged: "SafetyRatingReviewTaskUpdateChanged",
    fbrItemUpdateChanged: "FbrItemUpdateChanged",
    systemRuleChanged: "SystemRuleChanged",
    refreshOrder: "RefreshOrder",
    rightShipInspectionHistoryChanged: "RightShipInspectionHistoryChanged",
    incidentHistoryChanged: "IncidentHistoryChanged",
    voyageDataSubmissionHistoryChanged: "VoyageDataSubmissionHistoryChanged",
    safetyRatingReviewHistoryChanged: "SafetyRatingReviewHistoryChanged",
    subtaskAdded: "SubtaskAdded",
    logoutUser: "LogoutUser",
    rsDocumentAdded: "RSDocumentAdded",
    exportCustomReportReady: "ExportCustomReportReady",
    exportCustomReportStarted: "ExportCustomReportStarted",
    mouCleared: "MOUCleared",
    vesselsSynced: "VesselsSynced",
    listItemsDeleted: "ListItemsDeleted",
    pscInspectionHistoryChanged: "PscInspectionHistoryHistoryChanged",
    incidentsSynced: "IncidentsSynced",
    pscsSynced: "PscsSynced",
    pscUpdated: "PscUpdated",
    pscAiExtractionCompleted: "PscAiExtractionCompleted",
    pscAiExtractionStarted: "PscAiExtractionStarted",
    voyageLegDataAttachmentParsedChanged: "VoyageLegDataAttachmentParsedChanged",
    voyageDataExcelsGenerated: "VoyageDataExcelsGenerated",
    voyageEmissionsComputed: "VoyageEmissionsComputed",
    voyageResolveErrorStatusChanged: "VoyageResolveErrorStatusChanged",
    refreshInspectionTabletSyncStatus: "RefreshInspectionTabletSyncStatus",
    rightShipInspectionCompanyChanged: "RightShipInspectionCompanyChanged",
    peopleChanged: "PeopleChanged",
    displayNotification: "DisplayNotification",
    updateMfaSettings: "UpdateMfaSettings",
    entityStatusChanged: "EntityStatusChanged",
    docSubscoreChanged: "DocSubscoreChanged",
    ghgRatingChanged: "GhgRatingChanged",
    permissionsChanged: "PermissionsChanged",
    refreshSubscriptions: "RefreshSubscriptions",
    customerActiveStateChanged: "CustomerActiveStateChanged",
    rightshipInspectionInspectorAssigned: "RightshipInspectionInspectorAssigned",
    odataLegacyCwsaChanged: "ODataLegacyCwsaChanged",
    odataCwsaChanged: "ODataCwsaChanged",
    exportMepEmissionsDocumentStarted: "ExportMepEmissionsDocumentStarted",
    exportMepEmissionsDocumentReady: "ExportMepEmissionsDocumentReady",
    downloadMepVesselStarted: "DownloadMepVesselStarted",
    downloadMepVesselReady: "DownloadMepVesselReady",
    entityTypeGroup: (entityType: number) => {
        return entityType ? `entity-type-${entityType}` : null;
    }
}

export interface EntityStatusChangeModel {
    entityId: number;
    entityTypeId: number;
    vesselId: number;
    statusId: number;
    userName: string;
    userId: number;
    statusSnippet: string;
    comment: string;
    additionalMeta: {
        customerDecisionStatusDate: Date;
        customerDecisionComment: string;
        previousCustomerDecisionStatusId: number;
        previousCustomerDecisionStatusDate: Date;
        customerDecisionStatusBy: string;
        previousCustomerDecisionStatusBy: string;
        customerDecisionStatusId?: number;
        isClosed?: boolean;
        ghgRatingAtVetOutcome?: string;
        ghgRatingPlusAtVetOutcome?: boolean;
        isGhgRatingVerifiedAtVetOutcome?: boolean;
        safetyRatingAtVetOutcome?: number;
        safetyRatingTypeAtVetOutcome?: number;
    }
    misreportedReasonId: number;
    cancellationStatusReasonId: number
}